import React from 'react'
import { Image } from 'react-native'
import { DEMO_MATERIAL_TILE_ICON } from 'app/assets/images'

interface Props {
  size?: number
}

const BASE_SIZE = 64

const DemoMaterialTileImage = ({ size = BASE_SIZE }: Props) => {
  return (
    <Image source={DEMO_MATERIAL_TILE_ICON} resizeMode="contain" style={{ width: size, height: size }} />
  )
}

export default DemoMaterialTileImage
